import './partner.css'
import partnerLogo1 from '../../assets/images/partner-logo-1.png'
import partnerLogo2 from '../../assets/images/partner-logo-2.png'
import partnerLogo3 from '../../assets/images/partner-logo-3.png'
import partnerLogo4 from '../../assets/images/partner-logo-4.png'
import partnerLogo5 from '../../assets/images/partner-logo-5.png'
import partnerLogo6 from '../../assets/images/partner-logo-6.png'
import partnerLogo7 from '../../assets/images/partner-logo-7.png'
import partnerLogo8 from '../../assets/images/partner-logo-8.png'
import partnerLogo9 from '../../assets/images/partner-logo-9.png'
import partnerLogo10 from '../../assets/images/partner-logo-10.png'

const Partner = () => {
    return (
        <div className="partner-logo-area pb-100">
            <div className="container">
                <div className="partner-logo-slider">
                    <div className="partner-logo-img">
                        <img src={partnerLogo1} alt="images" />
                        <div className="partner-logo-two">
                            <img src={partnerLogo6} alt="images" />
                        </div>
                    </div>
                    <div className="partner-logo-img">
                        <img src={partnerLogo2} alt="images" />
                        <div className="partner-logo-two">
                            <img src={partnerLogo7} alt="images" />
                        </div>
                    </div>
                    <div className="partner-logo-img">
                        <img src={partnerLogo3} alt="images" />
                        <div className="partner-logo-two">
                            <img src={partnerLogo8} alt="images" />
                        </div>
                    </div>
                    <div className="partner-logo-img">
                        <img src={partnerLogo4} alt="images" />
                        <div className="partner-logo-two">
                            <img src={partnerLogo9} alt="images" />
                        </div>
                    </div>
                    <div className="partner-logo-img">
                        <img src={partnerLogo5} alt="images" />
                        <div className="partner-logo-two">
                            <img src={partnerLogo10} alt="images" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Partner